<template>
  <div class="privacy-clause">
    <div class="header">
    <TopBar :title ="title" />
    </div>
    <div class="content">
      <div class="text" v-if="title===$t('mine.tiaokuan')">
        <div class="title">{{$t('mine.tiaokuan')}}</div>
        <div class="date">प्रकाशन तारीख: मार्च 1, 2023</div>
        <div class="version">संस्करण – 1.0</div>
        <div class="desc" v-html="$t('ystk')">
        </div>
      </div>
      <div class="text" v-else>
        <div class="title">{{$t('mine.xieyi')}}</div>
        <div class="desc" v-html="$t('yhxy')"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Notify } from 'vant';
  import TopBar from '@/common/top-bar/index.vue'

  export default {
    name: 'PrivacyClauses',
    components: {
      TopBar
    },
    data () {
      return {
        title:this.$t("mine.tiaokuan"),
        iframeSrc:""
      }
    },
    methods: {
    },
    mounted () {

      if(this.$route.params.id === '1'){
        this.title = this.$t("mine.xieyi")
      }else{
        this.title = this.$t("mine.tiaokuan")
      }

    },
    activated () {
    }
  }
</script>

<style lang="stylus" scoped>
  /deep/.privacy-clause{
    width: 100%;
    height:100%;
    overflow: scroll;
    overflow-x: hidden;
    background-color: #F3F3F3;
    .header{
    }
    .content{
      padding: .4rem 0 0 0;
      padding-bottom: 0rem;
      .text{
        border-radius: 18px 18px 0 0;
        width: 100%;
        background: #FFFFFF;
        height: 100%;
        .title{
          padding-top:.4rem;
          padding-left:.4rem;
          font-weight: bold;
        }
        .date{
          padding-top:.4rem;
          padding-left:.4rem;
        }
        .version{
          padding-top:.4rem;
          padding-left:.4rem;
        }
        .desc{
          padding-top:.4rem;
          padding-left:.4rem;
          padding-right:.4rem;
          line-height:.6rem;
          height: 100%;
          h1{
            font-size: 18px;
            font-weight: bold;
            margin-top: 16px;
            margin-bottom: 16px;
          }
          h2{
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 16px;
          }
          p{
            font-size: 14px;
            margin-bottom: 16px;
            line-height: 1.75;
          }
          p.p-sub-1{
            text-indent: 24px;
          }
          p.p-sub-2{
            text-indent: 48px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/privacyClauses/PrivacyClauses.vue